import React from "react";
import formItemLayout from "../../../const/form/formItemLayout";
import { Form, Input } from 'antd';

function Email({ data, setData, handleInput, required = false, width, props }){
    return(
        <Form.Item 
            {...formItemLayout} 
            label="Email" 
            style={{marginTop: 25}}
            hasFeedback
            required={required}
        >
            <Input 
                id="email"
                value={data.email} 
                placeholder="Digite o email do usuario"
                name="email"
                style={ (width ? width : { width: "80%" } ) }
                onChange={e => handleInput(e, "", data, setData)}
            />
        </Form.Item>
    )
}

export default Email;


// WEBPACK FOOTER //
// ./src/components/common/form/Email.jsx